import React, { Component } from "react";
import { connect } from "react-redux";
import TrackedKeywordsTable from "../../components/TrackedKeywords/TrackedKeywordsTable";
import DashboardSettingsKeywordsTable from "../../components/DashboardSettings/DashboardSettingsKeywordsTable";
import { fetchTrackedKeywords, deleteKeyword } from "../../store/tracked_keywords/operations";
import { getSelectedWebsiteGuid } from "../../store/tracked_websites/selectors";
import {
  getSelectedDomainKeywords,
  isFetchingTrackedKeywords,
  keywordsBeingDeleted
} from "../../store/tracked_keywords/selectors";

class KeywordsTable extends Component {
  componentDidMount = _ => {
    this.props.fetchTrackedKeywords(this.props.selectedWebsiteGuid, this.props.domain);
  };

  render() {
    if (this.props.tableLocation === "dashboard_settings") {
      return (
        <DashboardSettingsKeywordsTable
          isLoading={this.props.isFetchingTrackedKeywords}
          domain={this.props.domain}
          keywords={this.props.keywords}
          handleDelete={keyword => this.props.deleteKeyword(keyword)}
          keywordsBeingDeleted={this.props.keywordsBeingDeleted}
        />
      );
    }
    return (
      <TrackedKeywordsTable
        isLoading={this.props.isFetchingTrackedKeywords}
        domain={this.props.domain}
        keywords={this.props.keywords}
        handleDelete={keyword => this.props.deleteKeyword(keyword)}
        keywordsBeingDeleted={this.props.keywordsBeingDeleted}
      />
    );
  }
}

const mapStateToProps = state => ({
  selectedWebsiteGuid: getSelectedWebsiteGuid(state),
  isFetchingTrackedKeywords: isFetchingTrackedKeywords(state),
  keywords: getSelectedDomainKeywords(state),
  keywordsBeingDeleted: keywordsBeingDeleted(state)
});

export default connect(mapStateToProps, { fetchTrackedKeywords, deleteKeyword })(KeywordsTable);
